import { DocumentType } from 'support/types';
import { TransactionData } from 'support/types/dtos';

export type ChartDetails = {
  name: string;
  data: Array<TransactionData>;
};

export type TransactionSeries = {
  name: string;
  data: Array<Array<number>>;
};

export type TransactionVolumeStats = {
  name: string;
  count: number;
  previousCount: number;
  change?: number;
  changeType?: string;
  type: DocumentType | undefined;
};

export type VolumeStats = {
  allTransactions: TransactionVolumeStats;
  orders?: TransactionVolumeStats;
  shippingNotices?: TransactionVolumeStats;
  invoices?: TransactionVolumeStats;
  dispatchInstructions?: TransactionVolumeStats;
  dispatchInstructionResponses?: TransactionVolumeStats;
};

export type DateRange = {
  label: string;
  value: number;
  interval: number;
  testId?: string;
};

export enum StatChangeType {
  level = 'level',
  increase = 'increase',
  decrease = 'decrease',
}
